/// <reference path="./custom-types.d.ts" />

import './date';
import './array';
import * as yup from 'yup';

// eslint-disable-next-line no-duplicate-imports
export * from 'yup';
export default yup;
